import { PropsWithChildren } from 'react';
import { Layout } from 'antd';
import { AppHeader } from 'components/Layout/Header';
import cn from './styles.module.scss';

const BaseLayout = ({ children }: PropsWithChildren) => {
  return (
    <Layout>
      <AppHeader />
      <Layout.Content className={cn.content}>
        {children}
      </Layout.Content>
    </Layout>
  );
};

export default BaseLayout;
